export default "__VITE_ASSET__BWB$Cbon__"